let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("574CX")).then(() => parcelRequire('8lLQC'));